import { FC } from 'react'

type Props = {
  className?: string
  solid?: boolean
  dark?: boolean
}

const BillsIcon: FC<Props> = ({ className, solid, dark }) => {
  if (dark && solid) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M19.5 21.75V4.75699C19.5 3.649 18.6939 2.70014 17.5933 2.57241C15.7584 2.35947 13.892 2.25 12 2.25C10.108 2.25 8.24156 2.35947 6.40668 2.57241C5.30608 2.70014 4.5 3.649 4.5 4.75699V21.75L8.25 20.25L12 21.75L15.75 20.25L19.5 21.75Z"
          fill="#2B343C"
        />
        <path
          d="M12.745 7.25C14.1722 7.25008 15.3329 8.41163 15.3329 9.83887C15.3326 11.2659 14.1721 12.4267 12.745 12.4268H10.8964V13.166H12.3749C12.7833 13.166 13.1151 13.4978 13.1151 13.9062C13.115 14.3146 12.7832 14.6455 12.3749 14.6455H10.8964V15.3848C10.8964 15.7932 10.5646 16.125 10.1561 16.125C9.7478 16.1248 9.41687 15.7931 9.41687 15.3848V7.98926C9.41703 7.58103 9.7479 7.25016 10.1561 7.25H12.745ZM10.8964 10.9482H12.745C13.3565 10.9481 13.8543 10.4504 13.8544 9.83887C13.8544 9.22729 13.3565 8.72962 12.745 8.72949H10.8964V10.9482Z"
          fill="white"
        />
      </svg>
    )
  }
  if (solid) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M19.5 21.75V4.75699C19.5 3.649 18.6939 2.70014 17.5933 2.57241C15.7584 2.35947 13.892 2.25 12 2.25C10.108 2.25 8.24156 2.35947 6.40668 2.57241C5.30608 2.70014 4.5 3.649 4.5 4.75699V21.75L8.25 20.25L12 21.75L15.75 20.25L19.5 21.75Z"
          fill="white"
        />
        <path
          d="M12.745 7.25C14.1722 7.25008 15.3329 8.41163 15.3329 9.83887C15.3326 11.2659 14.1721 12.4267 12.745 12.4268H10.8964V13.166H12.3749C12.7833 13.166 13.1151 13.4978 13.1151 13.9062C13.115 14.3146 12.7832 14.6455 12.3749 14.6455H10.8964V15.3848C10.8964 15.7932 10.5646 16.125 10.1561 16.125C9.7478 16.1248 9.41687 15.7931 9.41687 15.3848V7.98926C9.41703 7.58103 9.7479 7.25016 10.1561 7.25H12.745ZM10.8964 10.9482H12.745C13.3565 10.9481 13.8543 10.4504 13.8544 9.83887C13.8544 9.22729 13.3565 8.72962 12.745 8.72949H10.8964V10.9482Z"
          fill="#2B343C"
        />
      </svg>
    )
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 21.75V4.75699C19.5 3.649 18.6939 2.70014 17.5933 2.57241C15.7584 2.35947 13.892 2.25 12 2.25C10.108 2.25 8.24156 2.35947 6.40668 2.57241C5.30608 2.70014 4.5 3.649 4.5 4.75699V21.75L8.25 20.25L12 21.75L15.75 20.25L19.5 21.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7451 7.25C14.1723 7.25008 15.333 8.41163 15.333 9.83887C15.3328 11.2659 14.1722 12.4267 12.7451 12.4268H10.8965V13.166H12.375C12.7835 13.166 13.1152 13.4978 13.1152 13.9062C13.1151 14.3146 12.7834 14.6455 12.375 14.6455H10.8965V15.3848C10.8965 15.7932 10.5647 16.125 10.1562 16.125C9.74792 16.1248 9.41699 15.7931 9.41699 15.3848V7.98926C9.41715 7.58103 9.74802 7.25016 10.1562 7.25H12.7451ZM10.8965 10.9482H12.7451C13.3566 10.9481 13.8545 10.4504 13.8545 9.83887C13.8545 9.22729 13.3567 8.72962 12.7451 8.72949H10.8965V10.9482Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BillsIcon
